// What we remember, in this browser, about somebody who arrived from a team
// invite: that they still owe a password, and which company's welcome guide to
// show them. Per browser on purpose. The password itself is enforced by the
// server (the invite link dies once a password is set, and nothing else signs
// them in without one); this only decides when to ask.
const KEY = "sift_invite_arrival";

export function markInviteArrival(info) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...info, at: Date.now() }));
  } catch {
    /* private mode: the prompt simply will not appear */
  }
}

export function readInviteArrival() {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function updateInviteArrival(patch) {
  const cur = readInviteArrival();
  if (cur) markInviteArrival({ ...cur, ...patch });
}

export function clearInviteArrival() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
